import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { AgeGateProvider } from './components/AgeGateProvider';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { HomePage } from './pages/HomePage';
import { ExplorePage } from './pages/ExplorePage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { MarketplacePage } from './pages/MarketplacePage';
import { SciencePage } from './pages/SciencePage';
import { TermsPage } from './pages/TermsPage';
import { ContactPage } from './pages/ContactPage';
import { ScrollToTop } from './components/ScrollToTop';
import { StashPage } from './pages/StashPage';
import { BrandPage } from './pages/BrandPage';

import {
  LoginPage,
  RegisterPage,
  VerifyPage,
  ResetRequestPage,
  ResetConfirmPage,
  OAuthCallbackPage,
} from './pages/auth';
import {
  AdminLayout,
  AdminOverview,
  AdminProducts,
  AdminProductForm,
  AdminBrands,
  AdminBrandForm,
  AdminScraper,
  AdminAffiliates,
  AdminReviews,
  AdminUsers,
} from './pages/admin';

export function App() {
  return (
    <AuthProvider>
      <AgeGateProvider>
        <ScrollToTop />
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/thc-drinks" element={<ExplorePage />} />
            <Route path="/explore" element={<Navigate to="/thc-drinks" replace />} />
            <Route path="/products/:id/:slug?" element={<ProductDetailPage />} />
            <Route path="/brands/:slug" element={<BrandPage />} />
            <Route path="/buy-thc-drinks" element={<MarketplacePage />} />
            <Route path="/marketplace" element={<Navigate to="/buy-thc-drinks" replace />} />
            <Route path="/thc-drinks-guide" element={<SciencePage />} />
            <Route path="/science" element={<Navigate to="/thc-drinks-guide" replace />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contact" element={<ContactPage />} />

            {/* Auth routes */}
            <Route path="/auth/login" element={<LoginPage />} />
            <Route path="/auth/register" element={<RegisterPage />} />
            <Route path="/auth/verify" element={<VerifyPage />} />
            <Route path="/auth/reset" element={<ResetRequestPage />} />
            <Route path="/auth/reset-confirm" element={<ResetConfirmPage />} />
            <Route path="/auth/callback" element={<OAuthCallbackPage />} />

            {/* Protected routes */}
            <Route
              path="/stash"
              element={
                <ProtectedRoute>
                  <StashPage />
                </ProtectedRoute>
              }
            />
            {/* Legacy redirect */}
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <StashPage />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* Admin routes — protected by AdminLayout (checks admin group) */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminOverview />} />
            <Route path="brands" element={<AdminBrands />} />
            <Route path="brands/new" element={<AdminBrandForm />} />
            <Route path="brands/:id/edit" element={<AdminBrandForm />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="products/new" element={<AdminProductForm />} />
            <Route path="products/:id/edit" element={<AdminProductForm />} />
            <Route path="scraper" element={<AdminScraper />} />
            <Route path="affiliates" element={<AdminAffiliates />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="users" element={<AdminUsers />} />
          </Route>
        </Routes>
      </AgeGateProvider>
    </AuthProvider>
  );
}
